module.exports = "https://assets.meiaentrada.org.br/static/media/banco-de-dados-unificados.95da6f57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banco-de-dados-unificados.png
// module id = 254
// module chunks = 0